"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _effects = require("redux-saga/effects");

var _apiHelper = require("../api/api-helper");

var _checkinDataActions = require("../actions/checkinDataActions");

var _utils = require("../utils/mappings/utils");

var _links = require("../utils/mappings/links");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchCheckinData);

var extractCheckinData = function extractCheckinData(checkins, bookingCompanyId, primaryCustomer) {
    var countryCode = (0, _utils.getCountryCodeFromCustomerData)(primaryCustomer);
    var checkinLink = (0, _utils.getLink)(bookingCompanyId, _links.CHECKIN_LINK_MAP, countryCode);

    return checkins.reduce(function (checkinUrlsByCustomerId, checkin) {
        var checkinHash = checkin.id;
        checkinUrlsByCustomerId[checkin.customer.id] = checkinLink + "/" + checkinHash;

        return checkinUrlsByCustomerId;
    }, {});
};

function fetchCheckinData() {
    var bookingId, authToken, locale, primaryCustomer, _ref, checkinData, error, bookingCompanyId, checkinUrlsByCustomerId;

    return _regenerator2.default.wrap(function fetchCheckinData$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!true) {
                        _context.next = 35;
                        break;
                    }

                    _context.next = 3;
                    return (0, _effects.take)(_checkinDataActions.CHECKIN_DATA_REQUESTED);

                case 3:
                    _context.next = 5;
                    return (0, _effects.select)(function (state) {
                        return state.booking.id;
                    });

                case 5:
                    bookingId = _context.sent;
                    _context.next = 8;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 8:
                    authToken = _context.sent;
                    _context.next = 11;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 11:
                    locale = _context.sent;
                    _context.next = 14;
                    return (0, _effects.select)(function (state) {
                        return state.primaryCustomer;
                    });

                case 14:
                    primaryCustomer = _context.sent;
                    _context.next = 17;
                    return (0, _apiHelper.getCheckinData)(bookingId, authToken, locale);

                case 17:
                    _ref = _context.sent;
                    checkinData = _ref.checkinData;
                    error = _ref.error;
                    _context.next = 22;
                    return (0, _effects.select)(function (state) {
                        return _lodash2.default.get(state, "booking.booking_company.id", null);
                    });

                case 22:
                    bookingCompanyId = _context.sent;

                    if (!checkinData) {
                        _context.next = 31;
                        break;
                    }

                    _context.next = 26;
                    return (0, _effects.call)(extractCheckinData, checkinData, bookingCompanyId, primaryCustomer);

                case 26:
                    checkinUrlsByCustomerId = _context.sent;
                    _context.next = 29;
                    return (0, _effects.put)((0, _checkinDataActions.checkinDataReceived)(checkinUrlsByCustomerId));

                case 29:
                    _context.next = 33;
                    break;

                case 31:
                    _context.next = 33;
                    return (0, _effects.put)((0, _checkinDataActions.checkinDataRequestFailed)(error._error));

                case 33:
                    _context.next = 0;
                    break;

                case 35:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchCheckinData;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchCheckinData.js
// module id = 1410
// module chunks = 0